<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer005">
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">Making Vegan Meat</span></p>
<p class="Basic-Paragraph"> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MakingVeganMeat.vue?67cafe37